import React, { FC, ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { typography } from '@clds/typography';
import { NoMatch } from '@cld/empty-state';
import { messages } from '../../i18n';

export interface NoTransformationMatchProps {
  onCreateClick?: () => void;
  title?: string;
  subtitle?: ReactNode;
}

const Link = styled.a`
  cursor: pointer;
  ${typography.sm.url};
`;

const StyledNoMatch = styled(NoMatch)`
  height: 100%;
`;

export interface NoTransformationMatchComposition {
  Link: typeof Link;
}

export const NoTransformationMatch: FC<React.PropsWithChildren<NoTransformationMatchProps>> & NoTransformationMatchComposition = ({
  title,
  subtitle,
  onCreateClick,
}) => {
  const { formatMessage } = useIntl();

  const defaultSubtitle = useMemo(
    () =>
      formatMessage(messages.refineTransformationsSearch, {
        action: (...message: ReactNode[]) => [
          <Link data-testid="create-transformation-cta" key="message" onClick={onCreateClick}>
            {message}
          </Link>,
        ],
      }),
    [onCreateClick, formatMessage]
  );

  return <StyledNoMatch title={title || formatMessage(messages.noTransformationsMatch)} subtitle={subtitle || defaultSubtitle} />;
};

NoTransformationMatch.Link = Link;
